import React from 'react';

import fromObjectToDataAttributes from 'utils/converters/object/fromObjectToDataAttributes.util';

const SchedulerLoading = ({ message, dataAttributes }) => (
  <div data-bem="SchedulerLoading" className="loading-wrap" {...fromObjectToDataAttributes(dataAttributes)}>
    <div className="loading-anim">
      <div className="loading-title">
        <span>Loading Salon Data</span>
      </div>
    </div>
    <div data-bem="SchedulerLoading__feedback" className="loading-feedback">
      {message}
    </div>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default SchedulerLoading;
